import React, { Fragment } from "react";
import { useNavigate } from "react-router-dom";
import {
    ADD_ITEM_DETAILS,
    ADD_PAYMENT_INFO,
    ADD_RECEIVER_INFO,
    ADD_SHIPMENT_DETAILS,
} from "constants/global";

const FormSteps = ({
    currentStep,
    setShippingDetailsStep,
    validateFirstStep,
    validateSecondStep,
    validateThirdStep,
}) => {
    const steps = [
        {
            title: "Add Item Details",
            path: ADD_ITEM_DETAILS,
            isValid: validateFirstStep,
        },
        {
            title: "Add shipping details",
            path: ADD_SHIPMENT_DETAILS,
            isValid: validateSecondStep,
        },
        {
            title: "Add payment info",
            path: ADD_PAYMENT_INFO,
            isValid: validateThirdStep,
        },
        {
            title: "Enter receiver info",
            path: ADD_RECEIVER_INFO,
            isValid: validateThirdStep,
        },
    ];
    const currentStepIndex = steps.findIndex((step) => step.path === currentStep);

    return (
        <div className={`flex gap-4 min-w-[177px] mb-5 md:mb-0`}>
            <div className="flex items-center md:flex-col">
                {steps.map((step, index) => (
                    <Fragment key={index}>
                        <span
                            className={`${
                                currentStepIndex >= index ? "!bg-secondary" : "!bg-[#98A2B3]"
                            } rounded-full size-6 font-[450] text-base text-center text-[#F4F1FF]`}
                            onClick={() => step.isValid && setShippingDetailsStep(step.path)}
                        >
                            {index + 1}
                        </span>
                        {index + 1 !== steps.length && (
                            <span
                                className={`${
                                    currentStepIndex > index ? "!bg-secondary" : "!bg-[#C0CAD8]"
                                } w-10 md:w-[2px] h-1 md:h-5`}
                            />
                        )}
                    </Fragment>
                ))}
            </div>
            <div className="hidden md:flex flex-col !gap-5">
                {steps.map((step, index) => (
                    <p
                        key={index}
                        className={`font-medium cursor-pointer ${
                            currentStep === step.path ? "!text-secondary" : "!text-main"
                        }`}
                        onClick={() => step.isValid && setShippingDetailsStep(step.path)}
                    >
                        {step.title}
                    </p>
                ))}
            </div>
        </div>
    );
};

export default FormSteps;
